"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ButtonIcon extends _react.default.Component {
  render() {
    const icon = this.props.icon;

    if (!icon) {
      return false;
    }

    return _react.default.createElement("i", {
      className: "admin-button__icon  material-icons"
    }, icon);
  }

}

var _default = ButtonIcon;
exports.default = _default;
module.exports = exports.default;